/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Type_DefectiveInputs */

const en_claim_type_defective = /** @type {(inputs: Claim_Type_DefectiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defective product`)
};

/**
* | output |
* | --- |
* | "Defective product" |
*
* @param {Claim_Type_DefectiveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_type_defective = /** @type {((inputs?: Claim_Type_DefectiveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Type_DefectiveInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_type_defective(inputs)
});